import * as React from "react";
import { forwardRef } from "react";
const SvgLeftDoubleArrowDisabled = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" ref={ref} {...props}><g fill="#32325D" opacity={0.399}><path d="M7.41 1.41L6 0 0 6 6 12 7.41 10.59 2.83 6z" transform="translate(6 6)" /><path d="M12.41 1.41L11 0 5 6 11 12 12.41 10.59 7.83 6z" transform="translate(6 6)" /></g></svg>;
const ForwardRef = forwardRef(SvgLeftDoubleArrowDisabled);
export { ForwardRef as ReactComponent };
import __svgUrl from "/home/jenkins/agent/workspace/_Connect_service_dev_uat-release/src/images/left_double_arrow_disabled.svg?url";
export default __svgUrl;
